package com.bikompanion.data.theme

import dev.zacsweers.metro.ContributesBinding
import dev.zacsweers.metro.Inject
import com.bikompanion.data.cache.LocalStore
import com.bikompanion.data.cache.cacheKey
import com.bikompanion.domain.LanguagePreference
import com.bikompanion.domain.LanguagePreferencesRepository
import com.bikompanion.domain.di.AppScope

private const val LanguagePreferenceKey = "language_preference"

/** Stored by enum name; anything unrecognised falls back to [LanguagePreference.System]. */
@ContributesBinding(AppScope::class)
@Inject
class LanguagePreferencesRepositoryImpl(
    private val store: LocalStore,
) : LanguagePreferencesRepository {
    override fun getLanguagePreference(): LanguagePreference {
        val stored = store.read(cacheKey(LanguagePreferenceKey)) ?: return LanguagePreference.System
        return LanguagePreference.entries.firstOrNull { it.name == stored } ?: LanguagePreference.System
    }

    override fun setLanguagePreference(language: LanguagePreference) {
        store.write(cacheKey(LanguagePreferenceKey), language.name)
    }
}
